import { useCallback } from 'react';

import { useCreatePayoutAccount } from '@givebacks/api/core';
import {
  ButtonMantine,
  Center,
  Group,
  ImageMantine,
  Stack,
  Text,
  TextInput,
  notifications,
} from 'ui';
import { emailRegex, isNotEmpty, useField } from 'ui/Form';
import { svg_paypal } from 'ui/Icons';

const PayPalAccountForm = ({ onClose }: { onClose: () => void }) => {
  const { mutate: connectPaypal, isPending: isLoading } = useCreatePayoutAccount();

  const field = useField({
    initialValue: '',
    validate: (value) => {
      if (!value) return isNotEmpty('Email is invalid')(value);
      if (value) {
        return !emailRegex.test(value) ? 'Email is invalid' : null;
      }
    },
  });

  const handleConnectAccount = useCallback(async () => {
    const errors = await field.validate();
    if (errors) return;

    connectPaypal(
      {
        accountType: 'paypal',
        request: { pay_pal_account: { email: field.getValue() } },
      },
      {
        onSuccess: () => {
          notifications.show({
            title: 'Account Connected',
            message: 'Your account has been connected',
            variant: 'success',
          });
          onClose();
        },
        onError: () => {
          notifications.show({
            title: 'Error',
            message: 'There was an error connecting your account',
            variant: 'error',
          });
        },
      }
    );
  }, [field, connectPaypal, onClose]);

  return (
    <Stack gap="lg">
      <Center>
        <Group gap="xs">
          <Text fz={10}>Secured with</Text>
          <ImageMantine src={svg_paypal} h={22} w="auto" />
        </Group>
      </Center>
      <TextInput {...field.getInputProps()} placeholder="Email associated with account" />
      <ButtonMantine onClick={handleConnectAccount} loading={isLoading}>
        Connect Account
      </ButtonMantine>
    </Stack>
  );
};

export { PayPalAccountForm };
